import { render, staticRenderFns } from "./bgLayout.vue?vue&type=template&id=03d30489&scoped=true&"
var script = {}
import style0 from "./bgLayout.vue?vue&type=style&index=0&id=03d30489&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d30489",
  null
  
)

export default component.exports